/**
 * @description 导出通用配置
 */
module.exports = {
  title: '大和ライフネクスト',
  titleSeparator: ' - ',
  titleReverse: false,
  abbreviation: 'vab-admin-pro',
  copyright: '',
  keepAliveMaxNum: 20,
  routerMode: 'history',
  routesWhiteList: [
    '/login',
    '/register',
    '/callback',
    '/404',
    '/403',
    '/logout',
  ],
  loadingText: 'ローディング...',
  tokenName: 'accessToken',
  tokenTableName: 'admin-pro-token',
  storage: 'localStorage',
  recordRoute: true,
  logo: 'vuejs-fill',
  i18n: 'ja',
  messageDuration: 3000,
  errorLog: 'development',
  loginInterception: true,
  loginRSA: false,
  authentication: 'intelligence',
  supportVisit: false,
  rolesControl: false,
  uniqueOpened: false,
  defaultOpeneds: [
    '/vab',
    '/vab/table',
    '/vab/icon',
    '/vab/form',
    '/vab/editor',
    '/vab/editor',
  ],
  debounce: ['doEdit'],
  openFirstMenu: true,
  footerCopyright: false,
  accountUrl: process.env.VUE_APP_BASE_ACCOUNT,
  tomooniUrl: process.env.VUE_APP_TOMOONI_TY,
  worksUrl: process.env.VUE_APP_WORKS_TY,
}
